require('stylesheets/styles.scss');
require('scripts/main');

require.context('svg/', true);
require.context('png/', true);
require.context('icons/', true);
